<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单编码：" prop="signUpNo">
            <el-input
              v-model="query.signUpNo"
              placeholder="请输入订单编号"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item label="申请人身份：">
            <el-select
              v-model="query.userType"
              placeholder="全部"
              clearable
              size="small"
            >
              <el-option
                :label="item.name"
                :value="item.level"
                v-for="item in identityList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请人信息：" prop="nameOrPho">
            <el-input
              v-model="query.nameOrPho"
              placeholder="请输入姓名/手机号"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item label="报名方式：">
            <el-select
              v-model="query.source"
              placeholder="全部"
              clearable
              size="small"
            >
              <el-option label="App报名" :value="10"></el-option>
              <el-option label="后台添加" :value="20"></el-option>
              <el-option label="导入" :value="21"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会议：" prop="meetingTitle">
            <el-input
              v-model="query.meetingTitle"
              placeholder="请输入会议名称"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select
              v-model="query.timeType"
              placeholder="请选择"
              clearable
              size="small"
              style="width: 120px;"
            >
              <el-option label="提交时间" :value="0"></el-option>
              <el-option label="同意时间" :value="1"></el-option>
              <el-option label="驳回时间" :value="2"></el-option>
            </el-select>
            <el-date-picker
              v-model="dateTime"
              size="small"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始"
              end-placeholder="结束"
              style="margin-left: 10px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini"
              >搜索</el-button
            >
            <el-button type="info" @click="handleFilter" plain size="mini"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({ pageNo: 1 })">
          <el-tab-pane label="待审核" name="0"></el-tab-pane>
          <el-tab-pane label="同意申请" name="1"></el-tab-pane>
          <el-tab-pane label="驳回申请" name="2"></el-tab-pane>
        </el-tabs>
        <!-- <div class="btn-box">
          <el-button type="primary" plain size="mini" @click="handleDownload"
            >导出</el-button
          >
        </div> -->
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName">
        <el-table-column
          label="订单编号"
          prop="signUpNo"
          align="center"
          fixed
          width="200"
        />
        <el-table-column label="申请人信息" prop="" align="center" width="200">
          <template slot-scope="{ row }">
            <div v-if="row.userRealName">
              {{ row.userRealName
              }}{{ row.userLevelName ? "(" + row.userLevelName + ")" : ""
              }}<br />{{ row.userMobile }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="报名方式"
          prop="source"
          align="center"
          width="120"
        >
          <template slot-scope="{ row }">
            <div>
              {{
                row.source === 10
                  ? "App报名"
                  : row.source === 20
                  ? "后台添加"
                  : row.source === 21
                  ? "导入"
                  : ""
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="会议信息" prop="" align="left" width="240">
          <template slot-scope="{ row }">
            <div
              class="meeting-info-cell"
              style="display: flex; align-items: center;"
              v-if="row.meeting"
            >
              <el-image
                style="width: 36px; height: 36px; margin-right: 8px;"
                :src="row.meeting.imageUrl"
                :preview-src-list="[row.meeting.imageUrl]"
              ></el-image>
              <div>
                <div class="meeting-title">{{ row.meeting.title }}</div>
                <div
                  class="meeting-category"
                  style="font-size: 12px; color: #999;"
                >
                  会议类型：{{ row.meeting.categoryName }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="报名人数" prop="" align="center" width="100">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="handleShowParticipants(row)">{{
             row.carryPeopleNum+row.carryChildNum || 1
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="报名金额" prop="fee" align="center" width="120">
          <template slot-scope="{ row }">
            {{  row.paymentMethod === 30 ? formatFee(row.payVouchersFee):formatFee(row.fee) || 0 }}
          </template>
        </el-table-column>
        <el-table-column label="付款凭证" prop="" align="center" width="200">
          <template slot-scope="{ row }">
            <span class="imgs" v-if="getPayVoucherImages(row).length > 0">
              <el-image
                style="width: 50px; height: 50px; margin-right: 5px;"
                :src="item"
                :preview-src-list="getPayVoucherImages(row)"
                v-for="(item, index) in getPayVoucherImages(row)"
                :key="index"
              ></el-image>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="申请凭证" prop="" align="center" width="200">
          <template slot-scope="{ row }">
            <span class="imgs" v-if="row.applyVouchersUrl">
              <el-image
                style="width: 50px; height: 50px;margin-right:5px"
                :src="item"
                :preview-src-list="row.applyVouchersUrl.split(',')"
                v-for="(item, index) in row.applyVouchersUrl.split(',')"
                :key="index"
              ></el-image>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="入账金额" prop="" align="center" width="200">
          <template slot-scope="{ row }">
            {{ getAccountEntryAmount(row) }}
          </template>
        </el-table-column>
        <el-table-column label="支付单号" prop="" align="center" width="180">
          <template slot-scope="{ row }">
            <span>{{ getPayVoucherNums(row) }}</span>
          </template>
        </el-table-column>
        
        <el-table-column
          label="提交时间"
          prop="createdTime"
          sortable
          align="center"
          width="200"
        />
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="160"
          v-if="activeName === '0'"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleApprove(row)">
              同意
            </el-button>
            <el-button type="text" @click="handleReject(row)">
              驳回
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :pageNo.sync="query.pageNo"
        :pageSize.sync="query.pageSize"
        @pagination="doQueryList"
      />
    </el-card>
    <!-- 同意审核弹窗 -->
    <approve-dialog ref="approveDialog" @approve="handleApproveConfirm" />
    <!-- 查看凭证弹窗 -->
    <view-voucher-dialog ref="viewVoucherDialog" />
    <!-- 参会人弹窗 -->
    <el-dialog
      title="报名人数"
      :visible.sync="participantsDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div v-loading="participantsLoading" class="participants-list">
        <!-- 表头 -->
        <div class="participants-header">
          <div class="header-cell" style="width: 150px;">姓名</div>
          <div class="header-cell" style="width: 80px;">性别</div>
          <div class="header-cell" style="width: 150px;">与报名者关系</div>
          <div class="header-cell" style="width: 250px;">身份证号码</div>
          <div class="header-cell" style="flex: 1;">手机号码</div>
        </div>
        <!-- 表体 -->
        <div class="participants-body">
          <template v-for="(row, index) in participantsList">
            <div
              :key="index"
              class="participants-row"
              :class="{ 'row-even': index % 2 === 1 }"
            >
              <div class="body-cell" style="width: 150px;">
                <div class="cell-content">
                  <span class="name-info">{{ row.realName }}</span>
                </div>
              </div>
              <div class="body-cell" style="width: 80px;">
                <div class="cell-content">
                  {{ row.sex === 1 ? "男" : row.sex === 2 ? "女" : "-" }}
                </div>
              </div>
              <div class="body-cell" style="width: 150px;">
                <div class="cell-content">{{ row.relationship || "-" }}</div>
              </div>
              <div class="body-cell" style="width: 250px;">
                <div class="cell-content">
                  {{ row.idCardNo}}{{ row.isChild ? "(儿童)" : "(成人)" }}
                </div>
              </div>
              <div class="body-cell" style="flex: 1;">
                <div class="cell-content">{{ row.mobile}}</div>
              </div>
            </div>
            <!-- 显示儿童信息 -->
            <template v-if="row.child && row.child.length > 0">
              <div
                v-for="(child, childIndex) in row.child"
                :key="`child-${index}-${childIndex}`"
                class="participants-row child-row"
                :class="{ 'row-even': (index + childIndex + 1) % 2 === 1 }"
              >
                <div class="body-cell" style="width: 150px;">
                  <div class="cell-content" style="padding-left: 30px;">
                    <span class="name-info">{{ child.realName }}</span>
                  </div>
                </div>
                <div class="body-cell" style="width: 80px;">
                  <div class="cell-content">
                    {{ child.sex === 1 ? "男" : child.sex === 2 ? "女" : "-" }}
                  </div>
                </div>
                <div class="body-cell" style="width: 150px;">
                  <div class="cell-content">-</div>
                </div>
                <div class="body-cell" style="width: 250px;">
                  <div class="cell-content">
                    {{ maskIdCard(child.idCard) }}(儿童)
                  </div>
                </div>
                <div class="body-cell" style="flex: 1;">
                  <div class="cell-content">{{ maskMobile(child.mobile) }}</div>
                </div>
              </div>
            </template>
          </template>
          <div v-if="participantsList.length === 0" class="empty-data">
            暂无数据
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="participantsDialogVisible = false">返回</el-button>
      </div>
    </el-dialog>
    <!-- 驳回审核弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="rejectDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      class="reject-dialog"
    >
      <div class="reject-dialog-content">
        <div class="reject-icon-wrapper">
          <i class="el-icon-warning reject-icon"></i>
          <div class="reject-message">是否确认驳回申请</div>
        </div>
        <el-form
          :model="rejectForm"
          :rules="rejectFormRules"
          ref="rejectForm"
          label-width="100px"
        >
          <el-form-item label="驳回原因:" prop="reason">
            <el-input
              v-model="rejectForm.reason"
              type="textarea"
              :rows="4"
              placeholder="请输入驳回原因"
              maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmReject">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import meetingSignUpApi from "@/api/meeting/meetingSignUp";
import meetingSignUpCarryPeopleApi from "@/api/meeting/meetingSignUpCarryPeople";
import ApproveDialog from "./approveDialog.vue";
import ViewVoucherDialog from "./viewVoucherDialog.vue";

export default {
  components: {
    Pagination,
    ApproveDialog,
    ViewVoucherDialog
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // 订单编号
        signUpNo: undefined,
        // 报名人相关字段
        userId: undefined,
        userInfold: undefined,
        userType: undefined,
        nameOrPho: undefined,
        // 会议相关
        meetingTitle: undefined,
        // 报名方式：10-App报名, 20-后台添加, 21-导入
        source: undefined,
        // 只查询线下支付的报名
        paymentMethod: 30,
        // 支付凭证审核状态：10-待审核，20-已通过，30-已驳回
        payVouchersStatus: undefined
      },
      dateTime: null,
      activeName: "0",
      identityList: [],
      // 驳回弹窗相关
      rejectDialogVisible: false,
      rejectForm: {
        reason: ""
      },
      rejectFormRules: {
        reason: [
          { required: true, message: "驳回原因不能为空", trigger: "blur" }
        ]
      },
      currentRejectRow: null,
      // 参会人弹窗相关
      participantsDialogVisible: false,
      participantsLoading: false,
      participantsList: []
    };
  },
  created() {
    this.identityList = JSON.parse(localStorage.getItem("levelList") || "[]");
    this.doQueryList({
      pageNo: 1
    });
  },
  methods: {
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        signUpNo: undefined,
        userId: undefined,
        userInfold: undefined,
        userType: undefined,
        nameOrPho: undefined,
        meetingTitle: undefined,
        source: undefined,
        paymentMethod: 30,
        payVouchersStatus: undefined
      };
      this.dateTime = null;
      this.query.timeType = undefined;
      this.doQueryList({
        pageNo: 1
      });
    },
    /**
     * 选择框变化
     */
    handleSelectionChange(val) {
      this.selectItems = val;
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      });
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }

      // 根据tab设置支付凭证审核状态
      // 待审核(0) -> payVouchersStatus: 10
      // 已通过(1) -> payVouchersStatus: 20
      // 已驳回(2) -> payVouchersStatus: 30
      if (this.activeName === "0") {
        this.query.payVouchersStatus = 10; // 待审核
      } else if (this.activeName === "1") {
        this.query.payVouchersStatus = 20; // 已通过
      } else if (this.activeName === "2") {
        this.query.payVouchersStatus = 30; // 已驳回
      } else {
        this.query.payVouchersStatus = undefined;
      }

      const queryParams = {
        ...this.query
      };

      // 处理申请人信息（姓名/手机号）
      if (this.query.nameOrPho) {
        // 如果包含数字，可能是手机号，否则是姓名
        if (/^\d+$/.test(this.query.nameOrPho.trim())) {
          queryParams.userMobile = this.query.nameOrPho.trim();
          queryParams.nameOrPho = undefined;
        } else {
          queryParams.userName = this.query.nameOrPho.trim();
          queryParams.nameOrPho = undefined;
        }
      }

      // 处理会议名称筛选
      if (this.query.meetingTitle) {
        queryParams.meetingTitle = this.query.meetingTitle.trim();
      } else {
        queryParams.meetingTitle = undefined;
      }

      // 时间筛选
      if (this.dateTime && this.dateTime.length) {
        if (this.query.timeType === 0 || !this.query.timeType) {
          // 提交时间
          queryParams.createdTimeStart = this.dateTime[0];
          queryParams.createdTimeEnd = this.dateTime[1];
        } else if (this.query.timeType === 1) {
          // 同意时间
          queryParams.auditTimeStart = this.dateTime[0];
          queryParams.auditTimeEnd = this.dateTime[1];
        } else if (this.query.timeType === 2) {
          // 驳回时间
          queryParams.rejectTimeStart = this.dateTime[0];
          queryParams.rejectTimeEnd = this.dateTime[1];
        }
      }

      // 只查询线下支付的报名
      queryParams.paymentMethod = 30;

      this.listLoading = true;
      return meetingSignUpApi
        .listPayVouchersAudit(queryParams)
        .then(data => {
          // 根据实际返回数据结构调整
          if (data && data.data) {
            this.list = data.data.list || [];
            this.total = data.data.total || 0;
          } else if (data && data.list) {
            this.list = data.list || [];
            this.total = data.total || 0;
          } else {
            this.list = [];
            this.total = 0;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 查看详情
     */
    handleShowDetail(id) {
      this.$emit("handleShow", id, 2);
    },
    /**
     * 显示参会人
     */
    handleShowParticipants(row) {
      this.participantsDialogVisible = true;
      this.loadParticipants(row.signUpNo);
    },
    /**
     * 加载参会人列表
     */
    loadParticipants(signUpNo) {
      if (!signUpNo) {
        this.$message.error("报名号不能为空");
        return;
      }
      this.participantsLoading = true;
      meetingSignUpCarryPeopleApi
        .fetchListTeev2({
          signNo: signUpNo,
          isGetTransportation: false
        })
        .then(res => {
          if (res && res.data) {
            this.participantsList = res.data || [];
          } else {
            this.participantsList = [];
          }
        })
        .catch(error => {
          this.$message.error(error.msg || "获取参会人列表失败");
          this.participantsList = [];
        })
        .finally(() => {
          this.participantsLoading = false;
        });
    },
    /**
     * 手机号脱敏处理
     */
    maskMobile(mobile) {
      if (!mobile) return "-";
      if (mobile.length === 11) {
        return mobile.substring(0, 3) + "****" + mobile.substring(7);
      } else if (mobile.length > 11) {
        const phonePart = mobile.substring(0, 11);
        const extraPart = mobile.substring(11);
        return (
          phonePart.substring(0, 3) +
          "****" +
          phonePart.substring(7) +
          extraPart
        );
      }
      return mobile;
    },
    /**
     * 身份证脱敏处理
     */
    maskIdCard(idCard) {
      if (!idCard) return "-";
      if (idCard.length > 8) {
        return (
          idCard.substring(0, 4) +
          "***********" +
          idCard.substring(idCard.length - 4)
        );
      }
      return idCard;
    },
    /**
     * 格式化费用显示
     */
    formatFee(value) {
      if (value === null || value === undefined || value === '' || value === 0) {
        return '0.00';
      }
      const numValue = Number(value);
      if (isNaN(numValue)) {
        return '0.00';
      }
      return numValue.toFixed(2);
    },
    /**
     * 通过审核
     */
    handleApprove(row) {
      this.$refs.approveDialog.handleCreate(row);
    },
    /**
     * 确认审核通过
     */
    handleApproveConfirm(params, callback) {
      meetingSignUpApi
        .auditPass(params)
        .then(() => {
          this.$message.success("审核通过");
          this.doQueryList({});
          if (callback) callback();
        })
        .catch(error => {
          this.$message.error(error.msg || "审核失败");
          if (callback) callback();
        });
    },
    /**
     * 查看凭证
     */
    handleViewVoucher(row) {
      this.$refs.viewVoucherDialog.handleCreate(row);
    },
    /**
     * 驳回审核
     */
    handleReject(row) {
      this.currentRejectRow = row;
      this.rejectForm.reason = "";
      this.rejectDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.rejectForm) {
          this.$refs.rejectForm.clearValidate();
        }
      });
    },
    /**
     * 确认驳回
     */
    handleConfirmReject() {
      this.$refs.rejectForm.validate(valid => {
        if (valid) {
          const params = {
            id: this.currentRejectRow.id,
            reason: "【财务审核】" + this.rejectForm.reason
          };
          meetingSignUpApi
            .auditReject(params)
            .then(() => {
              this.$message.success("已驳回");
              this.rejectDialogVisible = false;
              this.doQueryList({});
            })
            .catch(error => {
              this.$message.error(error.msg || "驳回失败");
            });
        }
      });
    },
    /**
     * 获取付款凭证图片列表
     */
    getPayVoucherImages(row) {
      // 优先使用 payVouchersList
      if (row.payVouchersList && row.payVouchersList.length > 0) {
        return row.payVouchersList
          .map(item => item.payImg || item)
          .filter(Boolean);
      }
      return [];
    },
    /**
     * 获取付款单号列表（返回逗号分隔的字符串）
     */
    getPayVoucherNums(row) {
      // 优先使用 payVouchersList
      if (row.payVouchersList && row.payVouchersList.length > 0) {
        const nums = row.payVouchersList
          .map(item => item.payNum)
          .filter(num => num && num.trim());
        return nums.join(", ");
      }
      return "";
    },
    /**
     * 获取入账金额
     */
    getAccountEntryAmount(row) {
      const typeMap = {
        1: "余额",
        2: "零售价",
        3: "学费"
      };

      // 优先使用 giftAccountType 和 giftAccountAmount
      if (
        row.giftAccountType !== undefined &&
        row.giftAccountAmount !== undefined
      ) {
        const typeName = typeMap[row.giftAccountType] || "未知";
        return `${row.giftAccountAmount}${typeName}`;
      }

      // 其次使用 amount 字段（需要配合 giftAccountType）
      if (row.giftAccountType !== undefined && row.amount !== undefined) {
        const typeName = typeMap[row.giftAccountType] || "未知";
        return `${row.amount}${typeName}`;
      }

      // 如果返回的是 giftAccounts 对象，需要解析
      if (row.giftAccounts && typeof row.giftAccounts === "object") {
        const keys = Object.keys(row.giftAccounts);
        if (keys.length > 0) {
          // 取第一个有值的类型和金额
          const firstKey = keys.find(key => row.giftAccounts[key]);
          if (firstKey) {
            const typeName = typeMap[parseInt(firstKey)] || "未知";
            return `${row.giftAccounts[firstKey]}${typeName}`;
          }
        }
      }

      return "-";
    },
    /**
     * 导出
     */
    handleDownload() {
      // TODO: 实现导出功能
      this.$message.info("导出功能待实现");
    }
  }
};
</script>

<style scoped>
.imgs {
  display: flex;
  flex-wrap: wrap;
}

.reject-dialog-content {
  padding: 10px 0;
}

.reject-icon-wrapper {
  display: flex;
  align-items: center;
}

.reject-icon {
  font-size: 28px;
  color: #e6a23c;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
}

.reject-message {
  font-size: 16px;
  color: #303133;
  text-align: center;
}

.reject-dialog-content ::v-deep .el-form-item {
  margin-bottom: 0;
}

.reject-dialog-content ::v-deep .el-form-item__label {
  text-align: left;
  padding: 0;
  line-height: 32px;
}

.reject-dialog-content ::v-deep .el-textarea__inner {
  resize: vertical;
  min-height: 80px;
}

.reject-dialog ::v-deep .el-dialog__body {
  padding: 30px 20px 20px;
}

/* 参会人弹窗样式 */
.participants-list {
  border: 1px solid #ebeef5;
}

.participants-header {
  display: flex;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.participants-header .header-cell {
  padding: 12px;
  text-align: center;
  font-weight: 600;
  color: #606266;
  border-right: 1px solid #ebeef5;
}

.participants-header .header-cell:last-child {
  border-right: none;
}

.participants-body {
  max-height: 500px;
  overflow-y: auto;
}

.participants-row {
  display: flex;
  border-bottom: 1px solid #ebeef5;
  background-color: #fff;
}

.participants-row.row-even {
  background-color: #fafafa;
}

.participants-row:hover {
  background-color: #f5f7fa;
}

.participants-row.child-row {
  background-color: #f9f9f9;
}

.participants-row.child-row.row-even {
  background-color: #f0f0f0;
}

.participants-row .body-cell {
  padding: 12px;
  text-align: center;
  border-right: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.participants-row .body-cell:last-child {
  border-right: none;
}

.participants-row .body-cell .cell-content {
  width: 100%;
  word-break: break-word;
  line-height: 1.5;
  color: #6c6c6c;
  font-size: 11px;
}

.participants-row .body-cell .cell-content .name-info {
  color: #000f29;
  font-size: 14px;
}

.participants-list .empty-data {
  text-align: center;
  padding: 40px;
  color: #909399;
}
</style>
